import { render, staticRenderFns } from "./dsCulture.vue?vue&type=template&id=28960052&scoped=true&"
import script from "./dsCulture.vue?vue&type=script&setup=true&lang=js&"
export * from "./dsCulture.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./dsCulture.vue?vue&type=style&index=0&id=28960052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28960052",
  null
  
)

export default component.exports